export default {
  // Product-phase label — rendered as the in-app "Beta" chip next to the FlowRent wordmark
  beta: 'Beta',
  // Dashboard "needs attention" chips (overdue invoices / expiring leases)
  needs_attention: {
    overdue_cta_one: 'ใบแจ้งหนี้เกินกำหนด {{count}} รายการ',
    overdue_cta_other: 'ใบแจ้งหนี้เกินกำหนด {{count}} รายการ',
    overdue_aria_one: 'ใบแจ้งหนี้เกินกำหนด {{count}} รายการ ดูรายการ',
    overdue_aria_other: 'ใบแจ้งหนี้เกินกำหนด {{count}} รายการ ดูรายการ',
    expiring_cta_one: 'สัญญาใกล้หมดอายุ {{count}} รายการ',
    expiring_cta_other: 'สัญญาใกล้หมดอายุ {{count}} รายการ',
    expiring_aria_one: 'สัญญาใกล้หมดอายุ {{count}} รายการ ดูรายการ',
    expiring_aria_other: 'สัญญาใกล้หมดอายุ {{count}} รายการ ดูรายการ',
  },
  // Actions
  actions: {
    add: 'เพิ่ม',
    edit: 'แก้ไข',
    delete: 'ลบ',
    save: 'บันทึก',
    saving: 'กำลังบันทึก…',
    save_changes: 'บันทึกการเปลี่ยนแปลง',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    back: 'กลับ',
    next: 'ถัดไป',
    previous: 'ก่อนหน้า',
    close: 'ปิด',
    switch_language: 'เปลี่ยนภาษา',
    search: 'ค้นหา',
    filter: 'กรอง',
    clear: 'ล้าง',
    retry: 'ลองใหม่',
    download: 'ดาวน์โหลด',
    upload: 'อัปโหลด',
    view: 'ดู',
    create: 'สร้าง',
    select: 'เลือก',
    update: 'อัปเดต',
    remove: 'ลบออก',
    logout: 'ออกจากระบบ',
    delete_account: 'ลบบัญชี',
    collapse: 'ย่อ',
    setup: 'ตั้งค่า',
    more_actions: 'การดำเนินการเพิ่มเติม',
    discard: 'ยกเลิกการเปลี่ยนแปลง',
    hide: 'ซ่อน',
    show: 'แสดง',
    leave: 'ออกจากหน้า',
    stay: 'อยู่ที่นี่',
    skip_for_now: 'ข้ามไว้ก่อน',
    why_this_matters: 'ทำไมเรื่องนี้ถึงสำคัญ',
    got_it: 'รับทราบ',
    record_payment: 'บันทึกการชำระเงิน',
  },

  // Status
  status: {
    active: 'ใช้งาน',
    inactive: 'ไม่ใช้งาน',
    pending: 'รอดำเนินการ',
    completed: 'เสร็จสิ้น',
    cancelled: 'ยกเลิก',
    loading: 'กำลังโหลด...',
    error: 'ข้อผิดพลาด',
    success: 'สำเร็จ',
    vacant: 'ว่าง',
    occupied: 'มีผู้เช่า',
    signed: 'ลงนามแล้ว',
  },

  // Navigation
  nav: {
    dashboard: 'แดชบอร์ด',
    properties: 'อสังหาริมทรัพย์',
    customers: 'ลูกค้า',
    shared_owners: 'เจ้าของร่วม',
    // EP-135 Tier 0 — สมุดรายชื่อติดต่อ (sub-nav ภายใต้ /co-owners)
    shared_owner_directory: 'สมุดรายชื่อ',
    // EP-135 Tier 1 — การประชุม + คณะกรรมการ (gate: condominium_enabled)
    meetings: 'การประชุม',
    committee: 'คณะกรรมการ',
    leases: 'สัญญาเช่า',
    co_ownerships: 'เจ้าของร่วม',
    invoices: 'ใบแจ้งหนี้',
    maintenance: 'แจ้งซ่อม',
    parcels: 'พัสดุ',
    visitor_arrivals: 'การมาถึงของผู้มาเยือน',
    parking: 'ที่จอดรถ',
    expenses: 'ค่าใช้จ่าย',
    timesheet: 'ไทม์ชีท',
    announcements: 'ประกาศ',
    reports: 'รายงาน',
    templates: 'เทมเพลต',
    payments: 'การชำระเงิน',
    meters: 'ค่ามิเตอร์',
    caf: 'ค่าส่วนกลาง',
    parcel_settings: 'ตั้งค่าผู้จัดส่ง',
    activity_log: 'บันทึกกิจกรรม',
    team: 'ทีม',
    settings: 'ตั้งค่า',
    cmms: 'CMMS',
    equipment: 'อุปกรณ์',
    work_orders: 'ใบสั่งงาน',
    vendors: 'ผู้ให้บริการ',
    admin: 'ผู้ดูแล',
    bank_reconciliation: 'กระทบยอดธนาคาร',
    finance: 'การเงิน',
    operations: 'การดำเนินงาน',
    accounting: 'บัญชี',
    chart_of_accounts: 'ผังบัญชี',
    journal_entries: 'รายการบันทึกบัญชี',
    financial_statements: 'งบการเงิน',
    fixed_assets: 'สินทรัพย์ถาวร',
    debt_collection: 'ติดตามหนี้',
    closing_package: 'ปิดยอดรายเดือน',
    incentives: 'สิทธิประโยชน์',
    incentives_campaigns: 'แคมเปญ',
    incentives_catalog: 'รายการรางวัล',
    incentives_promotions: 'โปรโมชัน',
  },

  header: {
    resume_onboarding: 'ทำการตั้งค่าต่อ',
    resume_onboarding_title: 'คุณข้ามตัวช่วยการตั้งค่า คลิกเพื่อดำเนินการต่อ',
    signed_in_as: 'เข้าสู่ระบบในชื่อ',
    pricing_link: 'ราคา',
  },

  // Search
  search: {
    placeholder: 'ค้นหาทุกอย่าง...',
    no_results: 'ไม่พบผลลัพธ์',
    recent_searches: 'การค้นหาล่าสุด',
    pages: 'หน้า',
    keyboard_hint: 'Cmd+K',
    degraded_mode_banner: 'ระบบค้นหากำลังทำงานในโหมดลดประสิทธิภาพ (ผลลัพธ์บางส่วนอาจไม่ครบ) ระบบจะกลับมาทำงานปกติโดยอัตโนมัติ',
    categories: {
      property: 'อสังหาริมทรัพย์',
      customer: 'ลูกค้า',
      unit: 'ห้อง',
      lease: 'สัญญาเช่า',
      invoice: 'ใบแจ้งหนี้',
      maintenance: 'แจ้งซ่อม',
      parcel: 'พัสดุ',
      expense: 'ค่าใช้จ่าย',
      payment: 'การชำระเงิน',
      vehicle: 'ยานพาหนะ',
      equipment: 'อุปกรณ์',
      work_order: 'ใบสั่งงาน',
      vendor: 'ผู้ขาย',
      properties: 'อสังหาริมทรัพย์',
      customers: 'ลูกค้า',
      units: 'ห้อง',
      leases: 'สัญญาเช่า',
      invoices: 'ใบแจ้งหนี้',
    },
  },

  // Export
  export_data: {
    title: 'ส่งออกข้อมูล',
    format: 'รูปแบบ',
    csv: 'CSV',
    excel: 'Excel (XLSX)',
    date_range: 'ช่วงวันที่',
    columns: 'คอลัมน์',
    select_all: 'เลือกทั้งหมด',
    progress: 'กำลังส่งออก... {{progress}}%',
    download: 'ดาวน์โหลด',
    export_button: 'ส่งออก',
    processing: 'กำลังประมวลผล...',
    completed: 'ส่งออกเสร็จสิ้น',
    success: 'ส่งออก {{count}} รายการแล้ว',
    failed: 'ส่งออกล้มเหลว',
    billing_period: 'รอบบิล',
    all_periods: 'ทุกรอบ',
    custom_range: 'กำหนดเอง',
  },

  // Filters
  filters: {
    toggle: 'ตัวกรอง',
  },

  // Common labels
  labels: {
    image_unavailable: 'ไม่พบรูปภาพ',
    name: 'ชื่อ',
    email: 'อีเมล',
    phone: 'โทรศัพท์',
    address: 'ที่อยู่',
    property: 'อสังหาริมทรัพย์',
    date: 'วันที่',
    amount: 'จำนวน',
    price: 'ราคา',
    total: 'รวม',
    all: 'ทั้งหมด',
    all_properties: 'ทุกอาคาร',
    refreshing: 'กำลังโหลด…',
    loading: 'กำลังโหลด',
    more_options: 'ตัวเลือกเพิ่มเติม',
    options: 'ตัวเลือก',
    select_property: 'เลือกอสังหาริมทรัพย์',
    select_property_in_header: 'ใช้ตัวเลือกอสังหาริมทรัพย์ที่แถบด้านบนเพื่อเลือก',
    description: 'รายละเอียด',
    details: 'รายละเอียด',
    notes: 'หมายเหตุ',
    type: 'ประเภท',
    status: 'สถานะ',
    prerequisites: 'สิ่งที่ต้องมี',
    created_at: 'สร้างเมื่อ',
    updated_at: 'แก้ไขเมื่อ',
    actions: 'การดำเนินการ',
    property_reports: 'รายงานอสังหาริมทรัพย์',
    actions_menu: 'การดำเนินการ',
    settings: 'การตั้งค่า',
    pre_filled: 'กรอกจากขั้นตอนก่อนหน้า',
    serial: 'ซีเรียล',
    unit: 'ห้อง',
    open_menu: 'เปิดเมนู',
    close_menu: 'ปิดเมนู',
    close: 'ปิด',
    copy: 'คัดลอก',
    delete_row: 'ลบแถว',
    remove_file: 'ลบไฟล์',
    toggle_navigation: 'สลับเมนูนำทาง',
    user_menu: 'เมนูผู้ใช้',
    clear_search: 'ล้างการค้นหา',
  },

  // Pagination
  pagination: {
    page: 'หน้า',
    of: 'จาก',
    showing: 'แสดง',
    entries: 'รายการ',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    rows: '{{count}} รายการ',
    summary: '{{rows}} · {{count}} หน้า · หน้าละ {{perPage}}',
    summary_short: '{{rows}} · {{count}} หน้า',
    go_to_page: 'ไปที่หน้า',
  },

  // Empty states
  empty: {
    no_data: 'ไม่พบข้อมูล',
    no_results: 'ไม่พบผลลัพธ์',
  },

  // Errors
  errors: {
    required: 'จำเป็นต้องกรอก',
    invalid_email: 'อีเมลไม่ถูกต้อง',
    min_length: 'ต้องมีอย่างน้อย {{count}} ตัวอักษร',
    max_length: 'ต้องไม่เกิน {{count}} ตัวอักษร',
    positive_number: 'ต้องเป็นตัวเลขที่มากกว่า 0',
    something_went_wrong: 'เกิดข้อผิดพลาด',
    not_found: 'ไม่พบข้อมูล',
    app_crashed_title: 'เกิดข้อผิดพลาด',
    app_crashed_body: 'พบปัญหาที่ไม่คาดคิด กรุณาลองใหม่อีกครั้งหรือกลับไปยังหน้าหลัก',
    app_crashed_retry: 'ลองใหม่อีกครั้ง',
    app_crashed_home: 'กลับหน้าหลัก',
    // T149-010 (MON-1 Q2): รายการโอนเงินหนึ่งรายการในไฟล์ที่นำเข้าไม่สามารถบันทึกลงบัญชีได้
    // ระบบจึงยกเลิกการนำเข้าทั้งหมดและไม่มีการบันทึกข้อมูลใด ๆ
    stripe_payout_journal_failed: 'ไม่สามารถบันทึกรายการโอนเงินหนึ่งรายการในไฟล์นี้ลงบัญชีได้ ไม่มีการนำเข้าข้อมูล กรุณาลองใหม่อีกครั้งหรือติดต่อฝ่ายสนับสนุน',
  },

  // Confirmations
  confirm: {
    delete: 'คุณแน่ใจหรือไม่ว่าต้องการลบ?',
    unsaved_changes: 'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก ต้องการออกหรือไม่?',
  },

  // Dashboard
  dashboard: {
    // EP-155: การ์ด "ต้องจัดการ" ของแต่ละบทบาท ตัวเลขของเจ้าของ และบรรทัดปิดงวด
    todo: {
      title: 'ต้องจัดการ',
      nothing: 'ไม่มีงานค้าง',
      load_failed: 'โหลดข้อมูลไม่สำเร็จ',
      retry: 'ลองอีกครั้ง',
      show_list: 'แสดงรายการ',
      hide_list: 'ซ่อนรายการ',
      view_all: 'ดูทั้งหมด ({{n}})',
      forgot_one: '{{name}} ยังไม่เลิกงาน ตั้งแต่ {{date}} {{time}} น.',
      forgot_many: 'ยังไม่เลิกงาน {{n}} คน',
      forgot_action: 'แก้',
      slips: 'สลิปรอตรวจ {{n}} รายการ',
      slips_action: 'ตรวจสลิป',
      parking_unpaid: 'ค่าจอดรถค้างชำระ {{n}}',
      parking_unpaid_action: 'ดู',
      expenses_confirm: 'ค่าใช้จ่ายรอยืนยัน {{n}}',
      expenses_confirm_action: 'ยืนยันค่าใช้จ่าย',
      unidentified: 'รับเงินยังไม่ระบุผู้จ่าย {{n}}',
      unidentified_action: 'ระบุผู้จ่าย',
      bank: 'รายการธนาคารยังไม่จับคู่ {{n}}',
      bank_action: 'กระทบยอด',
      receipts: 'ค่าใช้จ่ายไม่มีใบเสร็จ {{n}}',
      receipts_action: 'ดูค่าใช้จ่าย',
      not_billed: 'ยังไม่ได้ออกใบแจ้งหนี้งวด {{period}}',
      not_billed_action: 'ออกใบแจ้งหนี้',
      overdue: 'ใบแจ้งหนี้เกินกำหนด {{n}} ใบ  {{amount}}',
      overdue_action: 'ติดตาม',
      expiring: 'สัญญาจะหมดใน 30 วัน {{n}} ฉบับ',
      expiring_action: 'ดูสัญญา',
      ends: 'หมด {{date}}',
      expired: 'สัญญาหมดอายุ ยังไม่ต่อ {{n}} ฉบับ ไม่ออกบิลค่าเช่าแล้ว',
      expired_action: 'ต่อหรือปิดสัญญา',
      expired_since_one: 'หมด {{date}} ({{count}} วันแล้ว)',
      expired_since_other: 'หมด {{date}} ({{count}} วันแล้ว)',
      superseded: 'มีสัญญาใหม่แล้ว ปิดสัญญาเดิม {{n}} ฉบับ',
      superseded_action: 'ปิดสัญญาเดิม',
      superseded_newer: 'หมด {{date}}  สัญญาใหม่ {{code}}',
      meters: 'มิเตอร์ยังไม่จดเดือนนี้ {{n}}',
      meters_action: 'จดมิเตอร์',
      meter_record: 'จด',
      parcels: 'พัสดุรอรับ {{n}}',
      parcels_action: 'ดูพัสดุ',
      maintenance: 'งานซ่อมค้าง {{n}}',
      maintenance_action: 'ดูงานซ่อม',
    },
    money: {
      period: 'งวด {{period}}',
      billed: 'ออกบิล',
      received: 'รับแล้ว',
      received_rate: '{{rate}}% ของที่ออกบิล',
      unpaid: 'ค้างชำระ',
      net_profit: 'กำไรสุทธิ',
      occupancy: 'อัตราเข้าพัก',
      rent_roll: 'ค่าเช่ารวม/เดือน',
      vacancy_gap: 'ขาดจากห้องว่าง',
      deposits_held: 'เงินประกันที่ถืออยู่',
    },
    closing: {
      title: 'ปิดงวด {{month}}',
      open: 'ยังค้าง {{n}} เรื่อง',
      clear: 'ไม่มีเรื่องค้าง',
      wht: 'หัก ณ ที่จ่าย {{n}}',
      action: 'เตรียมชุดปิดงวด',
    },
    no_building: 'ยังไม่มีอาคารในบัญชีนี้ เจ้าของบัญชีเป็นผู้ตั้งค่าเริ่มต้น',
    open_maintenance: 'งานซ่อมที่ยังไม่เสร็จ',
    waiting_parcels: 'พัสดุรอรับ',
    // EP-80: mobile QuickActionBar labels (staff-only bottom nav)
    // T003: record_payment, add_meter_reading, add_parcel added for staff ops CTAs
    // EP-154: การ์ดลงเวลาด้านบนแดชบอร์ดของพนักงานและผู้ดูแล
    shift: {
      duration: '{{hours}} ชม. {{minutes}} น.',
      clock_in: 'เข้างาน',
      clock_out: 'เลิกงาน',
      saving: 'กำลังบันทึก…',
      locating: 'กำลังหาตำแหน่ง…',
      tap_to_cancel: 'แตะเพื่อยกเลิก',
      cannot_clock_in: 'ลงเวลาเข้างานไม่ได้',
      cannot_clock_out: 'ลงเวลาเลิกงานไม่ได้',
      issue_location: 'ไม่ได้อนุญาตตำแหน่ง',
      errors: {
        shift_already_open: 'มีกะที่เปิดอยู่แล้ว กดเลิกงานก่อน',
        no_open_shift: 'ไม่มีกะที่เปิดอยู่',
        shift_too_long: 'กะนี้เกิน 24 ชั่วโมงแล้ว ปิดที่ตารางเวลาด้วยเวลาเลิกงานจริง',
        shift_too_short: 'กดเลิกงานหลังเข้างานสักครู่',
        clock_proof_required: 'ต้องมีทั้งเซลฟี่และตำแหน่ง',
        no_position: 'หาตำแหน่งไม่ได้ ลองอีกครั้ง',
        forbidden: 'สัปดาห์นี้ถูกล็อก กรุณาติดต่อผู้ดูแล',
        failed: 'บันทึกไม่สำเร็จ ลองอีกครั้ง',
      },
    },
    // EP-154: ใครเข้างานอยู่ตอนนี้ บนแดชบอร์ดผู้ดูแล
    team_today: {
      title: 'ทีมวันนี้',
      not_started: 'ยังไม่เข้างาน',
      since: 'ตั้งแต่ {{time}} น.',
      open_since: 'เปิดอยู่ตั้งแต่ {{date}} {{time}} น.',
      fix: 'แก้',
      view_timesheet: 'ดูตารางเวลา',
      in_count: 'เข้างาน {{present}}/{{total}}',
      show: 'แสดงรายชื่อ',
      hide: 'ซ่อนรายชื่อ',
      forgot_clock_out: '{{name}} เข้างาน {{date}} {{time}} น. ยังไม่เลิกงาน',
    },
    quick_actions: {
      // The staff bottom bar: five labels that fit one line each on a phone.
      bar: {
        record_payment: 'ชำระเงิน',
        new_invoice: 'ใบแจ้งหนี้',
        add_reading: 'จดมิเตอร์',
        log_maintenance: 'แจ้งซ่อม',
        quick_add: 'เพิ่มด่วน',
      },
      new_invoice: 'ใบแจ้งหนี้ใหม่',
      add_reading: 'จดมิเตอร์',
      log_maintenance: 'แจ้งซ่อม',
      quick_add: 'เพิ่มด่วน',
      record_payment: 'บันทึกการชำระเงิน',
      add_meter_reading: 'จดมิเตอร์',
      add_parcel: 'เพิ่มพัสดุ',
    },
    title: 'แดชบอร์ด',
    welcome: 'ยินดีต้อนรับ, {{name}}!',
    welcome_short: 'สวัสดี, {{name}}',
    total_properties: 'อสังหาริมทรัพย์ทั้งหมด',
    total_units: 'ห้องทั้งหมด',
    active_leases: 'สัญญาที่ใช้งาน',
    pending_invoices: 'ใบแจ้งหนี้รอชำระ',
    occupied_units: 'ห้องที่มีผู้เช่า',
    vacant_units: 'ห้องว่าง',
    occupancy_rate: 'อัตราการเข้าพัก',
    overdue_invoices: 'ใบแจ้งหนี้เกินกำหนด',
    revenue_this_month: 'รายรับเดือนนี้',
    billed_this_month: 'เรียกเก็บเดือนนี้',
    outstanding_balance: 'ยอดค้างชำระ',
    overdue_amount: 'ยอดเกินกำหนด',
    recent_invoices: 'ใบแจ้งหนี้ล่าสุด',
    recent_payments: 'การชำระเงินล่าสุด',
    view_all: 'ดูทั้งหมด',
    expiring_leases: 'สัญญาใกล้หมดอายุ',
    expiring_leases_notice: 'สัญญา {{count}} รายการใกล้หมดอายุภายใน 30 วัน',
    overdue_notice: 'ใบแจ้งหนี้เกินกำหนด {{count}} รายการ รวม ฿{{amount}}',
    overdue_widget_title: 'ใบแจ้งหนี้เกินกำหนด',
    overdue_widget_empty: 'ไม่มีใบแจ้งหนี้เกินกำหนด',
    overdue_days_late_one: 'เกินกำหนด {{count}} วัน',
    overdue_days_late_other: 'เกินกำหนด {{count}} วัน',
    no_recent_invoices: 'ไม่มีใบแจ้งหนี้ล่าสุด',
    no_recent_payments: 'ไม่มีการชำระเงินล่าสุด',
    no_expiring_leases: 'ไม่มีสัญญาใกล้หมดอายุ',
    logged_in_as: 'คุณเข้าสู่ระบบเป็น',
    for_account: 'สำหรับ',
    setup_guide_title: 'ยินดีต้อนรับสู่ FlowRent!',
    setup_guide_description: 'เริ่มต้นด้วยการสร้างอสังหาริมทรัพย์แรกของคุณ',
    setup_step_1_title: 'สร้างอสังหาริมทรัพย์',
    setup_step_1_description: 'เพิ่มอพาร์ทเมนต์หรืออาคารพร้อมประเภทห้องและห้อง',
    setup_step_2_title: 'เพิ่มลูกค้า',
    setup_step_2_description: 'ลงทะเบียนผู้เช่าและสร้างสัญญาเช่า',
    setup_step_3_title: 'เริ่มออกบิล',
    setup_step_3_description: 'ออกใบแจ้งหนี้และติดตามการชำระเงิน',
    setup_action: 'สร้างอสังหาริมทรัพย์',
    revenue_overview: 'ภาพรวมรายรับ',
    key_stats: 'สถิติสำคัญ',
    today_activity: 'กิจกรรมวันนี้',
    no_activity: 'ไม่มีกิจกรรมล่าสุด',
    meter_readings_progress: 'มิเตอร์เดือนปัจจุบัน',
    payments_today: 'การชำระเงินวันนี้',
    meter_readings_due: 'มิเตอร์ที่ต้องบันทึก',
    no_meters: 'ไม่พบมิเตอร์สำหรับอสังหาริมทรัพย์นี้',
    my_units: 'ห้องของฉัน',
    onboarding_complete: {
      row_link: 'ทำซ้ำขั้นตอนนี้',
    },
    onboarding_in_progress: {
      row_link: 'ดำเนินการต่อ',
    },
    // EP-109: horizontal card carousel — constant title + count-pill progress
    // badge, neutral-tense step copy (replaces the past-tense onboarding_complete
    // row copy above, which is now consumed by nothing).
    onboarding: {
      title: 'ตั้งค่าเพื่อเริ่มใช้งาน FlowRent',
      progress: '{{done}}/{{total}} เสร็จสิ้น',
      step_1_title: 'สร้างอสังหาริมทรัพย์',
      step_1_description: 'เพิ่มชื่อ ที่อยู่ และจำนวนห้องของอสังหาริมทรัพย์',
      step_2_title: 'ตั้งราคา',
      step_2_description: 'ตั้งสูตรคำนวณค่าเช่าและวิธีการชำระเงิน',
      step_3_title: 'เพิ่มห้องพัก',
      step_3_description: 'เพิ่มห้องพักหรือยูนิตที่เปิดให้เช่า',
      step_4_title: 'เพิ่มลูกค้า',
      step_4_description: 'เพิ่มชื่อและข้อมูลติดต่อของลูกค้าคนแรก',
      step_5_title: 'สร้างสัญญา',
      step_5_description: 'สร้างสัญญาเช่าเพื่อผูกลูกค้ากับห้องพัก',
      step_6_title: 'บันทึกค่ามิเตอร์',
      step_6_description: 'บันทึกค่ามิเตอร์น้ำและไฟฟ้า',
      step_7_title: 'ออกใบแจ้งหนี้',
      step_7_description: 'ออกใบแจ้งหนี้จากสัญญาเช่าและค่ามิเตอร์',
      step_8_title: 'บันทึกการชำระเงิน',
      step_8_description: 'บันทึกการชำระเงินตามใบแจ้งหนี้',
      cta_done: 'เสร็จแล้ว',
      cta_add: 'เพิ่ม',
    },
    // RPT-4 — BusinessSnapshot + owner dashboard slimming
    business_snapshot_title: 'ภาพรวมธุรกิจ', // [TH-review]
    view_all_reports: 'ดูรายงาน', // [TH-review]
    finish_setup_discover_title: 'ตั้งค่าให้สมบูรณ์และสำรวจ', // [TH-review]
    discover_dismiss: 'ปิด', // [TH-review]
    discover_payment_method: 'ตั้งค่าวิธีการชำระเงิน', // [TH-review]
    discover_carrier: 'เพิ่มผู้ให้บริการขนส่ง', // [TH-review]
    discover_line_oa: 'เชื่อมต่อ LINE Official Account', // [TH-review]
    discover_invite_team: 'เชิญสมาชิกทีม', // [TH-review]
    discover_try_feature: 'ลอง {{feature}} (ยังไม่เคยใช้)', // [TH-review]
    // T129-010: accountant dashboard widget labels
    accountant: {
      payments_pending: 'การชำระเงินรอตรวจสอบ',
      unmatched_bank_rows: 'รายการธนาคารที่ยังไม่จับคู่',
      missing_receipts: 'ค่าใช้จ่ายที่ไม่มีใบเสร็จ',
      wht_expenses: 'ค่าใช้จ่าย ภ.ง.ด. งวดนี้',
      current_period: 'งวดปัจจุบัน',
      closing_package: 'ปิดยอดรายเดือน',
    },
  },

  // T129-012: closing package page labels
  closing_package: {
    title: 'ปิดยอดรายเดือน',
    month_picker_label: 'งวด',
    completeness_title: 'รายการตรวจสอบความครบถ้วน',
    download_button: 'ดาวน์โหลดชุดเอกสาร',
    downloading: 'กำลังรวบรวม…',
    status_ok: 'ครบถ้วน',
    status_warning: 'ต้องดำเนินการ',
    checklist_invoices: 'ใบแจ้งหนี้',
    checklist_payments: 'การชำระเงิน',
    checklist_expenses: 'ค่าใช้จ่าย',
    checklist_pending_expenses: 'รายการโอนออกที่ยังไม่มีค่าใช้จ่าย',
    checklist_missing_receipts: 'ค่าใช้จ่ายที่ไม่มีใบเสร็จ',
    checklist_unmatched_bank: 'รายการธนาคารที่ยังไม่จับคู่',
    checklist_bank_statement: 'สเตทเมนต์ธนาคาร',
    bank_coverage_none: 'ยังไม่มีสเตทเมนต์ของเดือนนี้',
    bank_coverage_partial: 'สเตทเมนต์ครอบคลุมถึง {{date}}',
    checklist_pending_verification: 'การชำระเงินรอตรวจสอบ',
    checklist_unidentified_payments: 'การชำระเงินที่ยังไม่ระบุผู้จ่าย',
    warnings_note: 'บางรายการต้องดำเนินการ แต่ยังดาวน์โหลดได้',
    manifest_period: 'งวด',
    manifest_counts: 'จำนวนรายการ',
    manifest_warnings: 'คำเตือน',
  },

  // Currency
  currency: {
    thb: '฿',
    per_month: '/เดือน',
  },

  // Breadcrumbs
  breadcrumbs: {
    home: 'หน้าหลัก',
  },

  // File upload widget
  file_upload: {
    click_to_upload: 'คลิกเพื่ออัปโหลด',
    or_drag_drop: 'หรือลากไฟล์มาวาง',
    uploading: 'กำลังอัปโหลด…',
    files_counter: '{{count}}/{{max}} ไฟล์',
    error: 'อัปโหลดไม่สำเร็จ',
  },

  // Sort controls (EP-97) — shared across all list pages
  sort: {
    label: 'เรียงตาม',
    order_asc: 'น้อยไปมาก',
    order_desc: 'มากไปน้อย',
    by_newest: 'ใหม่ล่าสุดก่อน',
    by_oldest: 'เก่าสุดก่อน',
    by_name: 'ชื่อ',
    by_unit: 'ยูนิต / ห้อง',
    by_due_date: 'วันครบกำหนด',
    by_most_overdue: 'ค้างชำระนานสุด',
    by_amount: 'จำนวนเงิน',
    by_status: 'สถานะ',
    by_priority: 'ความสำคัญ',
    by_rating: 'คะแนน',
    by_expiring: 'ใกล้หมดอายุสุด',
    by_transaction_date: 'วันที่ทำรายการ',
    by_plate: 'ทะเบียนรถ',
    by_last_updated: 'อัปเดตล่าสุด',
    by_start_date: 'วันที่เริ่ม',
  },

  // List-page affordance strings (EP-97)
  list: {
    showing_period: 'กำลังแสดง {{period}}',
    all_periods: 'ทุกงวด',
    showing_filtered: 'กำลังแสดงมุมมองที่กรองแล้ว',
    show_all: 'แสดงทั้งหมด',
    total_count: 'ทั้งหมด {{count}} รายการ',
  },

  // F4: Pricing formula shared keys (consumed by Property, Unit, and Invoice editors)
  pricing_formula: {
    types: {
      discount: 'ส่วนลด',
    },
    discount_amount_placeholder: '20',
    discount_label_placeholder: 'ส่วนลดสำหรับลูกค้าประจำ',
    discount_label_aria: 'ป้ายส่วนลด',
    discount_amount_aria: 'จำนวนส่วนลด',
    // Fallback label when operator leaves the label field blank (used by F3 + F5)
    default_discount_label: 'ส่วนลด',
    discount_hint: 'ลดยอดรวมในใบแจ้งหนี้ ใช้ซ้อนกันได้ระหว่างระดับอสังหาฯ ยูนิต และใบแจ้งหนี้ ไม่มีเพดาน เจ้าของ/แอดมินรับผิดชอบ คำแนะนำ: ใช้ชื่อกำกับให้แตกต่างกัน ส่วนลดที่ปล่อยว่างจะถูกแยกอัตโนมัติ (ส่วนลด, ส่วนลด_2…) แต่จะแสดงเหมือนกันในใบแจ้งหนี้ถ้าไม่ระบุชื่อ',
    negative_total_warning: 'ยอดรวมจะติดลบหรือเป็น 0 ด้วยส่วนลดปัจจุบัน กรุณาตรวจสอบ',
  },

  // Shared SignaturePad control (lease e-sign) — no namespace of its own, lives in common
  signature_pad: {
    clear: 'ล้าง',
    confirm_signature: 'ยืนยันลายเซ็น',
    draw_hint: 'วาดลายเซ็นของคุณในกล่องด้านบน',
    captured: 'บันทึกลายเซ็นแล้ว',
  },

  // Shared DateInput control (EP-149 T149-090, PAY-4/DAT-2), no namespace of its own, lives in common
  date_input: {
    order_dd_mm_yyyy: 'วว/ดด/ปปปป',
    order_mm_dd_yyyy: 'ดด/วว/ปปปป',
    order_yyyy_mm_dd: 'ปปปป-ดด-วว',
    buddhist_conversion: 'แปลง พ.ศ. {{from}} เป็น ค.ศ. {{to}}',
    out_of_range: 'วันที่ต้องอยู่ระหว่าง {{min}} ถึง {{max}}',
    out_of_range_min: 'วันที่ต้องไม่ก่อน {{min}}',
  },

  // EP-160 section 2.3: a FlowRent support session tab (support's browser only)
  support_session: {
    starting: 'กำลังเปิดเซสชันช่วยเหลือ',
    expired_title: 'เซสชันหมดอายุ',
    expired_body: 'เซสชันช่วยเหลือนี้หมดเวลาหรือถูกปิดแล้ว ปิดแท็บนี้ แล้วเปิดเซสชันใหม่จากคอนโซลช่วยเหลือของ FlowRent',
    ended_title: 'จบเซสชันแล้ว',
    ended_body: 'เซสชันช่วยเหลือนี้จบแล้ว ปิดแท็บนี้ได้เลย',
    invalid_link_title: 'ลิงก์เซสชันนี้ใช้ไม่ได้',
    invalid_link_body: 'ลิงก์นี้ถูกใช้ไปแล้วหรือหมดอายุ ลิงก์ใช้ได้ครั้งเดียวภายใน 10 นาที เปิดเซสชันใหม่จากคอนโซลช่วยเหลือของ FlowRent',
    // EP-160 S3: the banner of a support tab, the hidden fields and the refusals.
    banner: {
      label: 'เซสชันช่วยเหลือของทีม FlowRent',
      account: 'บัญชี {{name}}',
      team: 'ทีม FlowRent ({{name}})',
      scope: 'ขอบเขต: {{label}}',
      time_left: 'เหลือ {{time}} ชม.',
      end: 'จบเซสชัน',
    },
    scopes: {
      read: 'ดูอย่างเดียว',
      setup: 'ตั้งค่าให้ฉัน',
      tenants: 'ตั้งค่าและกรอกผู้เช่าให้ฉัน',
    },
    hidden: '[ ซ่อน ]',
    hidden_description: 'ไม่แสดงในเซสชันของทีม FlowRent',
    lease_pdf: 'PDF สัญญา',
    field_locked_hint: 'ปิดบังในเซสชันของทีม FlowRent จึงแก้ไขไม่ได้',
    setup_no_tenants_notice: 'ขอบเขต "ตั้งค่าให้ฉัน" กรอกหรือแก้ข้อมูลผู้เช่าไม่ได้ ให้เจ้าของบัญชีกรอกเอง หรือขอขอบเขต "ตั้งค่าและกรอกผู้เช่าให้ฉัน"',
    import_setup_notice: 'ขอบเขต "ตั้งค่าให้ฉัน" นำเข้าได้เฉพาะแท็บอาคาร ราคา และห้อง แท็บผู้เช่าและสัญญาเช่าให้เจ้าของบัญชียืนยันเองภายหลัง',
    import_setup_tenant_rows: 'ไฟล์นี้มีผู้เช่าหรือสัญญาเช่า การแก้ไขในตารางจึงไม่ถูกบันทึก แต่ละแท็บนำเข้าตามที่อ่านได้จากไฟล์',
    blocked_title: 'หน้านี้ไม่เปิดให้ทีม FlowRent ในเซสชันช่วยเหลือ',
    blocked_body: 'เจ้าของบัญชีเปิดหน้านี้ได้เองเมื่อเข้าสู่ระบบ',
    blocked_home: 'กลับหน้าแรก',
    errors: {
      support_session_blocked: 'หน้านี้ไม่เปิดให้ทีม FlowRent ในเซสชันช่วยเหลือ',
      search_blocked: 'ในขอบเขตนี้ค้นหาด้วยชื่อหรือเบอร์โทรไม่ได้ ค้นหาด้วยเลขห้องหรือรหัสสัญญาเช่า',
      masked_value_in_write: 'บันทึกไม่ได้ เพราะมีข้อมูลที่ปิดบังในเซสชันของทีม FlowRent',
      scope_setup_no_tenants: 'บันทึกไม่ได้ ขอบเขต "ตั้งค่าให้ฉัน" กรอกหรือแก้ข้อมูลผู้เช่าไม่ได้',
    },
  },
}
